module.exports = __webpack_public_path__ + "static/media/BannerApi_PlantaRayo.515a53b2.png";